const assertUnreachable = (_: never): never => {
  throw new Error('Should not reach');
};

export default assertUnreachable;
